module.exports = __webpack_public_path__ + "static/media/setup-programing.1fcc94f3.svg";